import React, { useState, useEffect } from 'react';
import { IDinghyEvent } from '../dinghyEvents';
import { ConsoleView } from '../../common/consoleView';
import { Tab, Tabs } from 'react-bootstrap';
import { JsonEditor } from '@spinnaker/core';
import * as copy from 'copy-to-clipboard';
import './dinghyEventDetail.scss';

export interface IDinghyEventDetail {
  events: IDinghyEvent[];
  errorState: boolean;
  eventSelected: IDinghyEvent;
}

export const DinghyEventDetail = ({ eventSelected, errorState, events }: IDinghyEventDetail) => {
  const [key, setKey] = useState('content');
  const [copyState, setCopyState] = useState<string>('copy');

  useEffect(() => {
    setCopyState('copy')
  }, [eventSelected]);

  const copyToClipboard = () => {
    copy(eventSelected?.rendereddinghyfile);
    setCopyState('ok');
  };

  if (errorState || !events) {
    return <div/>;
  }

  if (events.length === 0) {
    return <div/>;
  }

  if (!eventSelected) {
    return <h4>Select an event above</h4>;
  }

  return (
    <div className="event-detail">
      {
        key === 'content' && (
          <div className="copy-btn-wrapper">
            <button className="copy-btn" onClick={copyToClipboard}>
              <span className={`glyphicon glyphicon-${copyState}`}/>
            </button>
          </div>
        )
      }
      <Tabs defaultActiveKey="content" animation={false} activeKey={key} onSelect={(k) => setKey(k)} id={'dinghyEventDetail'}>
        <Tab eventKey="content" title="Content">
          <JsonEditor value={eventSelected.rendereddinghyfile} readOnly={true}/>
        </Tab>
        <Tab eventKey="webhook_payload" title="Webhook payload">
          <pre>{JSON.stringify(JSON.parse(eventSelected.rawdata), undefined, 2)}</pre>
        </Tab>
        <Tab eventKey="logs" title="Logs">
          <ConsoleView input={eventSelected.message}/>
        </Tab>
      </Tabs>
    </div>
  );
};
